module.exports = __webpack_public_path__ + "img/choose-icon01.67dca449.png";